import React, { Component } from 'react';
import { _Alert, variable, _post, _getToken, _isLogin, _setTime } from './Function';
import SideBar from './SideBar';
import Loading from './Loading';
import '../css/Guarantor.css';
import { Link } from 'react-router-dom';

class Confirm extends Component {
    constructor(props) {
        super(props);
        this.state={ loadingShow: true, is_data: true, guarantor: [] };
        _isLogin().then( value => { 
            if ( value ) this.getGuarantor();
        });
    }

    getGuarantor = () => {
        let param = { token: _getToken(), platform: variable().platform };
        _post('get.loan.guarantee.php', param)
        .then(res => {
            if ( res.data.status ) {
                this.setState({ loadingShow: false, is_data: true, guarantor: res.data.data })
            } else {
                this.setState({ loadingShow: false, is_data: false })
                if ( res.data.responseText === 101 ) {
                    localStorage.clear();
                    _Alert('token_fail', '', 'แจ้งเตือน', 'พบการเข้าสู่ระบบจากอุปกรณอื่น');
                }
            }
        }).catch(err => { 
            this.setState({ loadingShow: false })
            _Alert('error'); 
        });
    }
    handleClick = () => {
        // window.location.assign("http://twitter.com/saigowthamr");
        

      };


    onAddTime = () => { _setTime() }

    render() {
        return (
            <div className="fix-content content-bar-bigger" onClick={(e) => this.onAddTime()}>
                <Loading show={this.state.loadingShow} />
                <SideBar onRefresh={false} />
                <div className="content-bar">

                    <div className="card">
                        <div className="card-title">
                            <div className="card-icon"><i className="fas fa-user-shield"></i></div>
                            <div className="card-title-text">ยืนยันยอด</div>
                        </div>
                        <div className="card-content">
                        {/* <button onClick={this.handleClick}>Twitter</button> */}
                        <Link to="myRoute" params='http://twitter.com/saigowthamr' target="_blank"></Link>
                        </div>
                    </div>
                
                </div>
            </div>
        );
    }
}

export default Confirm;